var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.ViaccessOrca = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.currentTime
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return this.player.videoElement.playbackRate
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return this.player.videoElement.webkitDroppedFrameCount
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (this.player.quality >= 0 && this.player.qualities && this.player.qualities.length) {
      var quality = this.player.qualities[this.player.quality]
      return quality.bitrate
    }
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    if (this.player.quality >= 0 && this.player.qualities && this.player.qualities.length) {
      var quality = this.player.qualities[this.player.quality]
      var width = quality.width
      var height = quality.height
      if (!width || !height) {
        width = this.player.videoElement.videoWidth
        height = this.player.videoElement.videoHeight
      }
      return youbora.Util.buildRenditionString(width, height, quality.bitrate)
    }
    return null
  },

  /** Override to return title */
  getTitle: function () {
    return this.player.videoElement.title || "Unknown"
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.player.isLive
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.videoElement.src
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return this.player.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Viaccess Orca"
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)
    // References
    this.references = []
    this.references['play'] = this.playListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['playing'] = this.playingListener.bind(this)
    this.references['error'] = this.errorListener.bind(this)
    this.references['seeking'] = this.seekingListener.bind(this)
    this.references['seeked'] = this.seekedListener.bind(this)
    this.references['ended'] = this.endedListener.bind(this)
    this.references['abort'] = this.endedListener.bind(this)
    this.references['buffering'] = this.joinListener.bind(this)
    // Register listeners
    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'play' event. */
  playListener: function () {
    this.fireStart()
    this.fireResume()
  },

  /** Listener for 'pause' event. */
  pauseListener: function () {
    if (this.player.videoElement.ended) {
      this.fireStop()
    }
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function () {
    this.fireResume()
    if (this.getPlayhead() > 0) {
      this.fireJoin()
    }
  },

  joinListener: function () {
    if (this.getPlayhead() > 0) {
      this.fireJoin()
    }
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e.data.code, e.data.message)
    this.fireStop()
  },

  /** Listener for 'seeking' event. */
  seekingListener: function () {
    this.fireSeekBegin()
  },

  /** Listener for 'seeked' event. */
  seekedListener: function () {
    this.fireSeekEnd()
  },

  /** Listener for 'ended' event. */
  endedListener: function () {
    this.fireStop()
  }
})

module.exports = youbora.adapters.ViaccessOrca



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 28
// module chunks = 0